<template>
    <div class="d-flex justify-content-center">
        <div v-for="(name,key) in list" :key="key" class="btn btn-link ml-3">
            <span v-if="activeKey == key">{{name}}</span>
            <router-link v-else :to="`/data/ai/${key}/`">{{ name }}</router-link>
        </div>
    </div>
</template>
<script>
export default{
    data(){
        return {
            list: {
                test: 'Тестирование',
                prompts: 'Запросы',
                list: 'Обработанные запросы',
            }
        }
    },
    computed: {

        activeKey() {

            const path = this.$route.path;
            const parts = path.split('/');
            if (parts.length >= 4 && parts[2] === 'ai') {
              return parts[3];
            }
            return null;

        }

    },
}
</script>